import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const MembershipSubscription = lazy(() => import("../../assets/js/react/components/membership/membershipSubscription")
  .then(module => ({ default: module.MembershipSubscription })));

const defaultMembershipJson = document
  ?.getElementById('membership-subscription')
  ?.getAttribute('data-default-membership');

CreateRoot('membership-subscription', <MembershipSubscription benefitsJson={defaultMembershipJson} />);
